/** @format */

export var getDaysFromTodayDate = function getDaysFromTodayDate(days) {
  var date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};